/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import t from "../../core/Error.js";
import { property as s } from "../../core/accessorSupport/decorators/property.js";
import "../../core/accessorSupport/ensureType.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import { subclass as o } from "../../core/accessorSupport/decorators/subclass.js";
import { writer as r } from "../../core/accessorSupport/decorators/writer.js";
import i from "./VisualVariable.js";
var p;
let a = p = class extends i {
  constructor(e) {
    super(e), this.axis = null, this.type = "rotation", this.rotationType = "geographic", this.valueExpressionTitle = null;
  }
  get cache() {
    return {
      hasExpression: !!this.valueExpression,
      compiledFunc: null
    };
  }
  writeValueExpressionTitleWebScene(e, s, o, r) {
    if (r?.messages) {
      const e = `visualVariables[${this.index}]`;
      r.messages.push(new t("property:unsupported", this.type + "VisualVariable.valueExpressionTitle is not supported in Web Scene. Please remove this property to save the Web Scene.", {
        instance: this,
        propertyName: e + ".valueExpressionTitle",
        context: r
      }));
    }
  }
  clone() {
    return new p({
      axis: this.axis,
      rotationType: this.rotationType,
      field: this.field,
      valueExpression: this.valueExpression,
      valueExpressionTitle: this.valueExpressionTitle,
      legendOptions: this.legendOptions?.clone()
    });
  }
};
e([s({
  readOnly: !0
})], a.prototype, "cache", null), e([s({
  type: ["heading", "tilt", "roll"],
  json: {
    origins: {
      "web-scene": {
        default: "heading",
        write: !0
      }
    }
  }
})], a.prototype, "axis", void 0), e([s({
  type: ["rotation"],
  json: {
    type: ["rotationInfo"]
  }
})], a.prototype, "type", void 0), e([s({
  type: ["geographic", "arithmetic"],
  json: {
    write: !0,
    origins: {
      "web-document": {
        write: !0,
        default: "geographic"
      }
    }
  }
})], a.prototype, "rotationType", void 0), e([s({
  type: String,
  json: {
    write: !0
  }
})], a.prototype, "valueExpressionTitle", void 0), e([r("web-scene", "valueExpressionTitle")], a.prototype, "writeValueExpressionTitleWebScene", null), a = p = e([o("esri.renderers.visualVariables.RotationVariable")], a);
const n = a;
export { n as default };